// Per-action role gating for the shared bed census/dashboard (ADR 0001 epic).
//
// Role names are free-text and admin-defined per tenant (same as the backend's
// CancellationRule / actor_role() — there is no fixed role enum), so this
// matches by substring the same way cancellation_rule_for() does on the
// backend (e.g. "nurse" matches an actual role of "Staff Nurse"). Adjust the
// keyword lists below if a tenant's role vocabulary doesn't fit.
//
// This is a UX nicety only — the backend (check_user_access + actor_role)
// is the real authorization boundary. When the role name hasn't loaded yet,
// actions are shown (fail-open) rather than hidden, since a brief loading
// window shouldn't make the dashboard look broken.

export const BED_DASHBOARD_ACTIONS = {
  PRINT_STICKER: "printSticker",
  MARK_CLEANING: "markCleaning",
  CANCEL_ADMISSION: "cancelAdmission",
  RETAIN_BED: "retainBed",
  TRANSFER_PATIENT: "transferPatient",
  ASSIGN_NURSE: "assignNurse",
  MANAGE_SETTINGS: "manageSettings",
};

const ACTION_ALLOWED_ROLE_KEYWORDS = {
  [BED_DASHBOARD_ACTIONS.PRINT_STICKER]: ["nurse", "nursing", "ward incharge", "incharge", "doctor", "front desk", "reception", "admin"],
  [BED_DASHBOARD_ACTIONS.MARK_CLEANING]: ["nurse", "nursing", "ward incharge", "incharge", "housekeeping", "admin", "front desk"],
  [BED_DASHBOARD_ACTIONS.CANCEL_ADMISSION]: ["admin", "front desk", "reception"],
  [BED_DASHBOARD_ACTIONS.RETAIN_BED]: ["nurse", "nursing", "ward incharge", "incharge", "admin", "front desk"],
  [BED_DASHBOARD_ACTIONS.TRANSFER_PATIENT]: ["nurse", "nursing", "ward incharge", "incharge", "admin", "front desk"],
  [BED_DASHBOARD_ACTIONS.ASSIGN_NURSE]: ["nurse", "nursing", "ward incharge", "incharge", "admin"],
  // Facility-wide IPD settings (auto-housekeeping). Narrower than the rest of
  // this file on purpose: it changes bed behaviour for the whole facility, not
  // one bed, so it is not a ward-floor action.
  [BED_DASHBOARD_ACTIONS.MANAGE_SETTINGS]: ["admin", "nursing supervisor", "nursing superintendent", "superintendent", "manager", "nurse manager"],
};

export function isActionAllowedForRole(action, roleName) {
  if (!roleName) return true;
  const allowed = ACTION_ALLOWED_ROLE_KEYWORDS[action];
  if (!allowed) return true;
  const normalized = String(roleName).trim().toLowerCase();
  return allowed.some((keyword) => normalized.includes(keyword));
}
